import { render, staticRenderFns } from "./progress-bar.vue?vue&type=template&id=2e5ede2c&"
import script from "./progress-bar.vue?vue&type=script&lang=js&"
export * from "./progress-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports